import { useState, useEffect } from "react";

function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isInStandaloneMode() {
  return window.navigator.standalone === true;
}

export default function IOSInstallBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("monyx_ios_banner_dismissed");
    if (isIOS() && !isInStandaloneMode() && !dismissed) {
      // Mostra após 3 segundos para não incomodar na entrada
      const t = setTimeout(() => setVisible(true), 3000);
      return () => clearTimeout(t);
    }
  }, []);

  function dismiss() {
    sessionStorage.setItem("monyx_ios_banner_dismissed", "1");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#0D1B2E",
        borderTop: "1px solid rgba(255,255,255,0.12)",
        padding: "16px 20px 28px",
        display: "flex",
        alignItems: "flex-start",
        gap: 14,
        boxShadow: "0 -8px 32px rgba(0,0,0,0.5)",
        animation: "slideUp 0.3s ease-out",
      }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
      `}</style>

      {/* Ícone do app */}
      <img
        src="/icon-192.png"
        alt="Monyxx"
        style={{ width: 48, height: 48, borderRadius: 12, flexShrink: 0 }}
      />

      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, color: "#fff", fontWeight: 700, fontSize: 15 }}>
          Instalar Monyxx no iPhone
        </p>
        <p style={{ margin: "4px 0 0", color: "rgba(255,255,255,0.65)", fontSize: 13, lineHeight: 1.4 }}>
          Toque em{" "}
          <span style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
            {/* Ícone Share do Safari */}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: "#4A9EFF", verticalAlign: "middle" }}>
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
              <polyline points="16 6 12 2 8 6" />
              <line x1="12" y1="2" x2="12" y2="15" />
            </svg>
            <strong style={{ color: "#4A9EFF" }}>Compartilhar</strong>
          </span>{" "}
          na barra do Safari e depois em{" "}
          <strong style={{ color: "#fff" }}>"Adicionar à Tela de Início"</strong>
        </p>
      </div>

      <button
        onClick={dismiss}
        style={{
          background: "none",
          border: "none",
          color: "rgba(255,255,255,0.5)",
          cursor: "pointer",
          padding: 4,
          flexShrink: 0,
          fontSize: 20,
          lineHeight: 1,
        }}
        aria-label="Fechar"
      >
        ×
      </button>
    </div>
  );
}
